import Vue from 'vue';
import { Component, Prop, Provide, Inject, Watch } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import qs from 'qs';
import { Validator } from 'vee-validate';
import StageHeader from '../../components/stageHeader';
import moment from 'moment';
import { cloneDeep, find, forEach, findIndex, map, sum } from 'lodash-es';
import TmsDatepicker from '../../components/tmsDatepicker';
import template from './quote.vue';
import MainButtonSet from '../../components/mainButtonSet';
import TrackProgressBar from '../../components/trackProgressBar';
import Datepicker from 'vuejs-datepicker';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsService from '../../services/axios/tmsService';
import ShippingDetailTruckload from './components/shippingDetailTruckload';
import ShippingDetailLastmile from './components/shippingDetailLastmile';
import ShippingDetailSharedTruckload from './components/shipping-detail-shared-truckload';
import DefaultSelect from '../../components/unisDefaultSelect';
import googleAutoComplete from '../../services/googleAPI/autoComplete';
import isStateMatchPostcode from '../../validation/validateLocation/isStateMatchPostcode';
import { Subject, Observable } from 'rxjs';
import 'rxjs/add/operator/debounceTime';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import { isTemplateMiddle } from 'typescript';
import switchBillingToService from '../../shared/switchBillingToService';
import UinsDefaultSelect from "../../components/unisDefaultSelect";
import localStorageUtil from "../../services/localStorageUtil/localStorageUtil";
import Moment from "moment/moment";
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        TrackProgressBar,
        Datepicker,
        ShippingDetailTruckload,
        ShippingDetailLastmile,
        ShippingDetailSharedTruckload,
        DefaultSelect,
        TmsDatepicker,
        UinsDefaultSelect
    },
})
export default class Quote extends Vue {
    @Inject() $validator: Validator;

    //#region  全局字段

    myAccountData: any = this.$store.getters.myAccountData;

    //#endregion 全局字段

    //#region  页面间接字段
    disabledDates: any = {
        to: new Date(Date.now() - 8640000),
    };
    isEditMode: boolean = true;
    userSource: boolean = true;
    isCalculating: boolean = false;
    shouldShowErrorTopBar: boolean = false;
    isErrorTotalShipmentValue: boolean = false;
    billToId: any = '';

    max_pallet: any = 6;
    fnToTalfreightValue: Subject<void> = new Subject();
    errorTopBarMessage: string =
        'Quote details are missing. Please provide information for the required highlighted fields.';
    quoteResult: any = {};
    accList: Array<Object> = [];
    additionalAccList: Array<Object> = [];
    filteredAdditionalAccList: Array<Object> = [];
    checkedManifestLinesTruckload: Array<any> = [];
    manifestLineTemplate: any = {
        manifest_product_id: '',
        manifest_pallet_dimension_id: '',
        manifest_carton: '',
        manifest_class: '',
        manifest_code: '',
        manifest_code_id: '',
        manifest_content: '',
        manifest_line_id: '',
        manifest_linear: '',
        manifest_pallet: '',
        manifest_space: '',
        manifest_value: '',
        manifest_volume: '',
        manifest_weight: '',
    };
    errorProduct: Boolean = false;

    isRequestnewquote: false;
    //#endregion 页面间接字段

    //#region  页面直接字段
    isTruckload: boolean = true;
    isLastmile: boolean = false;
    isSharedTruckload: boolean = false;
    timeArr: any = [];
    quoteData: any = [];
  productTemplates: Array<Object> = []; // 显示 product template 列表
    businessTypes: Array<any> = [
        { key: 1, code: null, title: 'Business' },
        { key: 2, code: 'CON', title: 'Construction Site' },
        { key: 3, code: 'SHOW', title: 'Convention Center' },
        { key: 4, code: null, title: 'Freight Carrier Terminal' },
        { key: 5, code: 'RES', title: 'Home/Residential' },
        { key: 6, code: null, title: 'Military Base' },
        { key: 7, code: null, title: 'Self Storage/Mini Storage' },
        { key: 8, code: null, title: 'Religious Institution' },
    ];
    unisFacilities: Array<any> = [];
    // lastMile
    lastMileFormInitData = {
        shipper_type: 'zipcode',
        shipper_zipcode: '',
        shipper_city: '',
        shipper_state: '',
        shipper_isResidentialAddress: false,
        shipper_selectedBusinessType: '',
        shipper_estimateShippingDate: '',
        shipper_selectedUnisFacility: '',
        shipper_isLiftGateRequired: false,

        consignee_zipcode: '',
        consignee_city: '',
        consignee_state: '',

        shippingProducts: <any>[], // 要寄的 product 列表
        shippingProduct: {
            // 增加 product 时，把这个 Push 到 shippingProducts
            selectedProduct: '',
            newProductName: '',
            quantity: '',
            width: '',
            height: '',
            length: '',
            weight: '',
            isPalletsStackable: false,
            isSaveItemToProducts: false,
            isRoomOfChoice: false,
            isWhiteGlovePackagingRemoval: false,
        },

        selectedAdditionalServices: [],
        comments: '',
        quoteNumber: '', // 示例：Quote #12345
        totalQuoteCharge: 0,
        shipmentDistance: 0,
        transitTime: '',
        totalWeight: 0,
        quoteDetails: [],
        appointment_date: '',
        earliest_time: '',
        latest_time: '',
    };
    lastMileForm = Object.assign({}, this.lastMileFormInitData);

    // TruckLoad 页面
    truckloadFormInitData = {
        shipper_type: 'zipcode',
        shipper_zipcode: '',
        shipper_city: '',
        shipper_state: '',
        shipper_isResidentialAddress: false,
        shipper_selectedBusinessType: '',
        shipper_isLiftGateRequired: false,
        shipper_selectedUnisFacility: '',

        consignee_type: 'zipcode',
        consignee_zipcode: '',
        consignee_city: '',
        consignee_state: '',
        consignee_isResidentialAddress: false,
        consignee_selectedBusinessType: '',
        consignee_isLiftGateRequired: false,
        consignee_selectedUnisFacility: '',

        shippingProducts: <any>[], // 要寄的 product 列表
        shippingProduct: {
            // 增加 product 时，把这个 Push 到 shippingProducts
            selectedProduct: '',
            newProductName: '',
            selectedPalletDimension: '',
            quantity: '',
            width: '',
            height: '',
            length: '',
            weight: '',
            class: '',
            showDetail: false,
            isPalletsStackable: false,
            isSaveItemToProducts: false,
        },

        selectedAdditionalServices: <any>[],
        comments: '',

        quoteNumber: '', // 示例：Quote #12345
        totalQuoteCharge: 0,
        shipmentDistance: 0,
        transitTime: '',
        totalWeight: 0,
        quoteDetails: [],
        total_freight_value: <any>'',
        appointment_date: '',
        earliest_time: '',
        latest_time: '',
    };
    truckloadForm = Object.assign({}, this.truckloadFormInitData);

    sharedTruckloadFormInitData = {
        shipper_type: 'zipcode',
        shipper_zipcode: '',
        shipper_city: '',
        shipper_state: '',
        shipper_isResidentialAddress: false,
        shipper_selectedBusinessType: '',
        shipper_isLiftGateRequired: false,
        shipper_selectedUnisFacility: '',

        consignee_type: 'zipcode',
        consignee_zipcode: '',
        consignee_city: '',
        consignee_state: '',
        consignee_isResidentialAddress: false,
        consignee_selectedBusinessType: '',
        consignee_isLiftGateRequired: false,
        consignee_selectedUnisFacility: '',

        shippingProducts: <any>[], // 要寄的 product 列表
        shippingProduct: {
            // 增加 product 时，把这个 Push 到 shippingProducts
            selectedProduct: '',
            newProductName: '',
            selectedPalletDimension: '',
            quantity: '',
            width: '',
            height: '',
            length: '',
            weight: '',
            class: '',
            showDetail: false,
            isPalletsStackable: false,
            isSaveItemToProducts: false,
        },

        selectedAdditionalServices: <any>[],
        comments: '',

        quoteNumber: '', // 示例：Quote #12345
        totalQuoteCharge: 0,
        shipmentDistance: 0,
        transitTime: '',
        totalWeight: 0,
        quoteDetails: [],
        total_freight_value: <any>'',
        appointment_date: '',
        earliest_time: '',
        latest_time: '',
    };
    sharedTruckloadForm = Object.assign({}, this.sharedTruckloadFormInitData);

    validationStarted: boolean = false;

    //#endregion 页面直接字段

    //#region 计算属性

    get lm_shipper_isUnisFacility() {
        if (this.lastMileForm.shipper_type == 'unisFacility') {
            return true;
        }
        return false;
    }
    get lm_shipper_isZipcode() {
        if (this.lastMileForm.shipper_type == 'zipcode') {
            return true;
        }
        return false;
    }
    get stl_shipper_isUnisFacility() {
        if (this.sharedTruckloadForm.shipper_type == 'unisFacility') {
            return true;
        }
        return false;
    }
    get stl_shipper_isZipcode() {
        if (this.sharedTruckloadForm.shipper_type == 'zipcode') {
            return true;
        }
        return false;
    }
    get stl_consignee_isUnisFacility() {
        if (this.sharedTruckloadForm.consignee_type == 'unisFacility') {
            return true;
        }
        return false;
    }
    get stl_consignee_isZipcode() {
        if (this.sharedTruckloadForm.consignee_type == 'zipcode') {
            return true;
        }
        return false;
    }
    get tl_shipper_isUnisFacility() {
        if (this.truckloadForm.shipper_type == 'unisFacility') {
            return true;
        }
        return false;
    }
    get tl_shipper_isZipcode() {
        if (this.truckloadForm.shipper_type == 'zipcode') {
            return true;
        }
        return false;
    }
    get tl_consignee_isUnisFacility() {
        if (this.truckloadForm.consignee_type == 'unisFacility') {
            return true;
        }
        return false;
    }
    get tl_consignee_isZipcode() {
        if (this.truckloadForm.consignee_type == 'zipcode') {
            return true;
        }
        return false;
    }

    //#endregion 计算属性

    //#region  Watch

    @Watch('myAccountData.billing.locationId')
    onBilltoChange(val: string, oldVal: string, event: any) {
        if (parseInt(val) != 0 && parseInt(val) != NaN) {
            this.setProductTemplates();
        }
    }

    @Watch('isTruckload')
    @Watch('isSharedTruckload')
    @Watch('isLastmile')
    @Watch('truckloadForm.shipper_type')
    @Watch('sharedTruckloadForm.shipper_type')
    @Watch('lastMileForm.shipper_type')
    @Watch('truckloadForm.consignee_type')
    @Watch('isEditMode')
    mountAutoComplete(val: string, oldVal: string, event: any) {
        this.$nextTick(() => {
            this._zipAutoCompletes();
        });
    }

    @Watch('additionalAccList')
    @Watch('checkedManifestLinesTruckload')
    checkAdditionalService() {
        if (!this.additionalAccList || !this.checkedManifestLinesTruckload) {
            return;
        }

        const form = this.isTruckload
            ? this.truckloadForm
            : this.isSharedTruckload
            ? this.sharedTruckloadForm
            : null;
        if (!form) {
            return;
        }

        form.selectedAdditionalServices = [];
        this.checkedManifestLinesTruckload.forEach((item: any) => {
            if (item.shipment_code) {
                let selectedAcc: any = this.additionalAccList.find(
                    (o: any) => o.code == item.shipment_code
                );
                if (selectedAcc) {
                    form.selectedAdditionalServices.push(Object.assign({}, selectedAcc));
                }
                if (item.shipment_code == 'PL') {
                    form.shipper_isLiftGateRequired = true;
                }
                if (item.shipment_code == 'DL') {
                    form.consignee_isLiftGateRequired = true;
                }
            }
        });
        // lastmile no need
    }

    //#endregion Watch

    //#region  生命周期函数

    async getUserBillToId() {
        let params: any = {
            UserID: localStorage.UserID,
            UserToken: localStorage.UserToken,
        };
        await switchBillingToService.post().then(
            (res: any) => {
                if (res.data.billing) {
                    this.max_pallet = res.data.billing.max_pallet ? res.data.billing.max_pallet : 6;
                    this.billToId = res.data.billing.location_id;
                    if (res.data.billing && res.data.billing.location_payment_type != 'deposit')
                        this.userSource = false;
                    else this.userSource = true;
                    this.getAccList();
                    this.setProductTemplates();
                    this.getAdditionalAccList();
                } else this.userSource = false;
            },
            (err: any) => {}
        );
    }

    created() {
        this.$store.dispatch('getMyAccountData');
        this.getUserBillToId();
        this.getFacilities();
        this.timeArr = this.generateTimeArray();

        const query: any = this.$route.query;
        this.isRequestnewquote = query.isRequestnewquote;
        if (query.quoteNumber == undefined) {
            this.initProductList();
        }
        if (
            query.quoteNumber != undefined &&
            (isNaN(parseInt(query.quoteNumber)) || parseInt(query.quoteNumber) <= 0)
        ) {
            this.err('Quote number is invalid.');
            return;
        } else {
            this.getQuoteAndFillForm(query);
        }

        this.$validator.extend('stateMatchPostcode', {
            validate: isStateMatchPostcode,
            getMessage: (field: string, params: any, data: any) => {
                return data.message;
            },
        });
      this.getEditData(query.quoteNumber);
    }

    mounted() {
      this._zipAutoCompletes();
        if (this.myAccountData.billing.locationId) {
            this.setProductTemplates();
        }

        this.fnToTalfreightValue
            .debounceTime(800)
            .subscribe(this.fillterTotalfreightValue, err => {});
    }

    fillterTotalfreightValue() {
        this.popError({
            isRemove: true,
        });

        const form = this.isTruckload
            ? this.truckloadForm
            : this.isSharedTruckload
            ? this.sharedTruckloadForm
            : null;
        if (!form) {
            return;
        }

        let excessiveLengthShipmentsIndex: any = findIndex(form.selectedAdditionalServices, [
            'code',
            'EXVAL',
        ]);
        if (!form.total_freight_value) {
            form.total_freight_value = null;
            form.selectedAdditionalServices.splice(excessiveLengthShipmentsIndex, 1);
        }

        if (!form.total_freight_value && excessiveLengthShipmentsIndex > -1) {
            form.selectedAdditionalServices.splice(excessiveLengthShipmentsIndex, 1);
            this.popError({
                isRemove: true,
            });
            this.isErrorTotalShipmentValue = false;
            return;
        }
        if (!form.total_freight_value && excessiveLengthShipmentsIndex < 0) {
            this.popError({
                isRemove: true,
            });
            this.isErrorTotalShipmentValue = false;
            return;
        }
        let totalfreightValue = Number(form.total_freight_value);

        if (totalfreightValue == 0 || totalfreightValue > 100000 || totalfreightValue < 1) {
            this.popError({
                text: `Please enter a value between 1 and 100,000.`,
            });
        } else {
            this.popError({
                isRemove: true,
            });
            let excessiveLengthShipments = find(this.filteredAdditionalAccList, {
                code: 'EXVAL',
            });
            if (excessiveLengthShipments) {
                this.isErrorTotalShipmentValue = false;
                form.selectedAdditionalServices.push(excessiveLengthShipments);
            }
        }
    }

    checkAccessorials(service: any) {
        const form = this.isTruckload
            ? this.truckloadForm
            : this.isSharedTruckload
            ? this.sharedTruckloadForm
            : null;
        if (!form) {
            return;
        }

        this.popError({
            isRemove: true,
        });
        let serviceShipments = findIndex(form.selectedAdditionalServices, service);
        if (serviceShipments > -1) {
            form.selectedAdditionalServices.splice(serviceShipments, 1);
        } else {
            form.selectedAdditionalServices.push(service);
        }
        if (service.code === 'EXVAL') {
            let totalfreightValue = Number(form.total_freight_value);
            let excessiveLengthShipments = find(form.selectedAdditionalServices, {
                code: 'EXVAL',
            });
            if (excessiveLengthShipments) {
                if (!totalfreightValue) {
                    this.isErrorTotalShipmentValue = true;
                    this.popError('Please declare a value amount.');
                } else if (totalfreightValue > 100000 || totalfreightValue < 1) {
                    this.popError({
                        text: 'Please enter a value between 1 and 100,000.',
                    });
                    this.isErrorTotalShipmentValue = true;
                }
            } else {
                this.isErrorTotalShipmentValue = false;
                this.popError({
                    isRemove: true,
                });
            }
        }
    }

    _zipAutoCompletes() {
        this.zipAutoComplete({
            id: 'autoComplete01',
            value: this.truckloadForm,
            key1: 'shipper_zipcode',
            key2: 'shipper_city',
            key3: 'shipper_state',
        });
        this.zipAutoComplete({
            id: 'autoComplete03',
            value: this.truckloadForm,
            key1: 'consignee_zipcode',
            key2: 'consignee_city',
            key3: 'consignee_state',
        });

        this.zipAutoComplete({
            id: 'autoComplete05',
            value: this.sharedTruckloadForm,
            key1: 'shipper_zipcode',
            key2: 'shipper_city',
            key3: 'shipper_state',
        });
        this.zipAutoComplete({
            id: 'autoComplete06',
            value: this.sharedTruckloadForm,
            key1: 'consignee_zipcode',
            key2: 'consignee_city',
            key3: 'consignee_state',
        });

        this.zipAutoComplete({
            id: 'autoComplete02',
            value: this.lastMileForm,
            key1: 'shipper_zipcode',
            key2: 'shipper_city',
            key3: 'shipper_state',
        });
        this.zipAutoComplete({
            id: 'autoComplete04',
            value: this.lastMileForm,
            key1: 'consignee_zipcode',
            key2: 'consignee_city',
            key3: 'consignee_state',
        });
    }

    updated() {
        // console.log(this);
    }

    //#endregion 生命周期函数

    //#region 设置页面字段
    setQuoteType(type: string) {
        if (type === 'truckload') {
            this.isTruckload = true;
            this.isLastmile = false;
            this.isSharedTruckload = false;
            if (this.truckloadForm.shippingProducts.length == 0) {
                this.truckloadForm.shippingProducts.push(this.generateTruckloadProduct());
            }
        }
        if (type === 'lastmile') {
            this.isLastmile = true;
            this.isTruckload = false;
            this.isSharedTruckload = false;
            if (this.lastMileForm.shippingProducts.length == 0) {
                this.lastMileForm.shippingProducts.push(this.generateLastmileProduct());
            }
        }
        if (type === 'sharedTruckload') {
            this.isLastmile = false;
            this.isTruckload = false;
            this.isSharedTruckload = true;
            if (this.sharedTruckloadForm.shippingProducts.length == 0) {
                this.sharedTruckloadForm.shippingProducts.push(
                    this.generateSharedTruckloadProduct()
                );
            }
        }
    }

    setProductTemplates() {
        tmsServiceBackend
            .post('product/getProducts', qs.stringify({ bill_to: this.billToId }))
            .then(response => {
                const result = response.data;
                if (result.status == 1) {
                    this.productTemplates = result.data;
                    this.errorProduct = false;
                } else {
                    this.errorProduct = true;
                }
            })
            .catch(error => {
                this.errorProduct = true;
            });
    }

    async getFacilities() {
        tmsServiceBackend.get('/cpv2/quote/getWiseFacilities').then(response => {
            this.unisFacilities = response.data.data;
        });
    }

    async getAccList() {
        try {
            let response = await tmsService.post('write_new/get_tms_acc_name_v2.php');
            this.accList = response.data;
        } catch (error) {}
    }

    getAdditionalAccList() {
        tmsServiceBackend.get(`/quote/getTmsAccList?billto_id=${this.billToId}`).then(response => {
            const data: Array<Object> = Object.values(response.data.data);
            this.getFilteredAdditionalAccLists(data);
            this.additionalAccList = data;
        });
    }

    getFilteredAdditionalAccLists(additionalAccLists: Array<Object>) {
        // this.filteredAdditionalAccList = additionalAccLists.filter((acc: any) => {
        //   // Lift Gate Service,  Residential PU or Delivery
        //   const accShouldBeFiltered = ["ACC-10019", "DL", "PL", "MO"];
        //   return accShouldBeFiltered.indexOf(acc.code) === -1;
        // });
        this.filteredAdditionalAccList = additionalAccLists;
    }

    initProductList() {
        this.lastMileForm.shippingProducts.length = 0;
        this.truckloadForm.shippingProducts.length = 0;
        this.sharedTruckloadForm.shippingProducts.length = 0;
        this.lastMileForm.shippingProducts.push(this.generateLastmileProduct());
        this.truckloadForm.shippingProducts.push(this.generateTruckloadProduct());
        this.sharedTruckloadForm.shippingProducts.push(this.generateSharedTruckloadProduct());
    }

    addProduct() {
        if (this.isLastmile) {
            this.lastMileForm.shippingProducts.push(this.generateLastmileProduct());
        }
        if (this.isTruckload) {
            this.truckloadForm.shippingProducts.push(this.generateTruckloadProduct());
        }
        if (this.isSharedTruckload) {
            this.sharedTruckloadForm.shippingProducts.push(this.generateSharedTruckloadProduct());
        }
    }

    generateLastmileProduct() {
        let maxId = Math.max(...this.lastMileForm.shippingProducts.map((o: any) => o.id), 0);
        return Object.assign({ id: maxId + 1 }, this.lastMileForm.shippingProduct);
    }

    generateTruckloadProduct() {
        let maxId = Math.max(...this.truckloadForm.shippingProducts.map((o: any) => o.id), 0);
        return Object.assign({ id: maxId + 1 }, this.truckloadForm.shippingProduct);
    }

    generateSharedTruckloadProduct() {
        let maxId = Math.max(...this.sharedTruckloadForm.shippingProducts.map((o: any) => o.id), 0);
        return Object.assign({ id: maxId + 1 }, this.sharedTruckloadForm.shippingProduct);
    }

    removeProduct(index: number) {
        if (this.isLastmile) {
            this.lastMileForm.shippingProducts.splice(index, 1);
        }
        if (this.isTruckload) {
            this.truckloadForm.shippingProducts.splice(index, 1);
        }
        if (this.isSharedTruckload) {
            this.sharedTruckloadForm.shippingProducts.splice(index, 1);
        }
    }

    cancel() {
        this.lastMileForm = Object.assign({}, this.lastMileFormInitData);
        this.truckloadForm = Object.assign({}, this.truckloadFormInitData);
        this.sharedTruckloadForm = Object.assign({}, this.sharedTruckloadFormInitData);
        this.initProductList();
    }

    async zipAutoComplete(moudel: any) {
        if (document.getElementById(moudel.id) == null) {
            return;
        }

        let autoComplete = new googleAutoComplete(moudel.id);
        autoComplete.setShortStateName();
        while (true) {
            let result: any = await autoComplete.searchResult();
            this.$set(moudel.value, moudel.key1, result.postal_code);
            this.$set(moudel.value, moudel.key2, result.city);
            this.$set(moudel.value, moudel.key3, result.state);
        }
    }

    closeErrorTopBar() {
        this.shouldShowErrorTopBar = false;
    }

    //#endregion 设置页面字段

    //#region  请求接口
    validateSubmit() {
        let shippingProducts = this.truckloadForm.shippingProducts;
        forEach(shippingProducts, (shippin: any) => {
            if (!shippin.isPalletsStackable) {
                if (Number(shippin.weight) > 10000) {
                    this.err(
                        'Your order may require a volume LTL or TL quote. Please contact UNIS Customer Service for assistance.'
                    );
                }
            }
            if (shippin.isPalletsStackable) {
                if (Number(shippin.weight) > 19999 || Number(shippin.quantity) > 9) {
                    this.err(
                        'Your order may require a volume LTL or TL quote. Please contact UNIS Customer Service for assistance.'
                    );
                }
            }
        });
    }

    submit() {
        this.$validator.validateAll().then(res => {
            this.validateSubmit();
            this.validateErrors(this);
            if (res) {
                this.backendSubmit();
            }
        });
    }

    private routerPush(quoteId: string) {
        this.$router.push({
            name: 'estimatedQuote',
            query: {
                quoteId: quoteId,
            },
        });
    }
    cloneDeepData: any;

    backendSubmit() {
        if (this.truckloadForm.total_freight_value) {
            let totalfreightValue = Number(this.truckloadForm.total_freight_value);
            if (totalfreightValue != 0 && totalfreightValue) {
                if (totalfreightValue > 100000 || totalfreightValue < 1) {
                    this.popError({
                        text: `Please enter a value between 1 and 100,000.`,
                    });
                    return;
                }
            }
        }
        let params: any = {};
        if (this.truckloadForm.appointment_date) {
          params.appointment_date = Moment(this.truckloadForm.appointment_date).format('YYYY-MM-DD');
          if (this.truckloadForm.earliest_time) {
            params.earliest_time = Moment('06/20/2021' + ' ' + this.truckloadForm.earliest_time).format(
              'HH:mm'
            );
          }
          if (this.truckloadForm.latest_time) {
            params.latest_time = Moment('06/20/2021' + ' ' + this.truckloadForm.latest_time).format(
              'HH:mm'
            );
          }
        }
        if (this.isLastmile) {
            this.cloneDeepData = cloneDeep(this.lastMileForm);
            let postData = this.getRequestDataLastmile();
            // let totalPallet: any = sum(map(postData.manifest_lines, 'manifest_carton'));
            // if (totalPallet > this.max_pallet) {
            //   this.err('Please wait for approval from your sales representative.');
            //   return;
            // }
            if (this.isRequestnewquote) this.$delete(postData, 'input_quote_id');
            this.isCalculating = true;
            this.errorTopBarMessage = '';
            this.shouldShowErrorTopBar = false;
            tmsServiceBackend
                .post('quote/lastMileService', qs.stringify(postData))
                .then(response => {
                    this.isCalculating = false;
                    if (parseInt(response.data.status) <= 0) {
                        this.err(response.data.message);
                        this.lastMileForm = this.cloneDeepData;
                        this._zipAutoCompletes();
                        return;
                    }
                    const data = response.data.data;
                    if (data && data.quote_id > 0) {
                        // this.isEditMode = false;
                        // this.quoteResult = data;
                        this.lastMileForm.quoteNumber = data.quote_id;
                        if (params) {
                          localStorageUtil.setItemToStorage('quoteData_' + data.quote_id, params);
                        }
                        this.routerPush(data.quote_id);
                    }
                })
                .catch(err => {
                    this.isCalculating = false;
                });
        } else if (this.isSharedTruckload) {
            this.cloneDeepData = cloneDeep(this.sharedTruckloadForm);
            let postData = this.getRequestDataSharedTruckload();
            if (this.isRequestnewquote) {
                this.$delete(postData, 'input_quote_id');
            }
            this.isCalculating = true;
            this.errorTopBarMessage = '';
            this.shouldShowErrorTopBar = false;
            tmsServiceBackend
                .post('quote/shareTruckLoad', qs.stringify(postData))
                .then(response => {
                    this.isCalculating = false;
                    if (parseInt(response.data.status) <= 0) {
                        this.err(response.data.message);
                        this.sharedTruckloadForm = this.cloneDeepData;
                        this._zipAutoCompletes();
                        return;
                    }
                    const data = response.data.data;
                    if (data && data.quote_id > 0) {
                        this.sharedTruckloadForm.quoteNumber = data.quote_id;
                        if (params) {
                          localStorageUtil.setItemToStorage('quoteData_' + data.quote_id, params);
                        }
                        this.routerPush(data.quote_id);
                    }
                })
                .catch(err => {
                    this.isCalculating = false;
                });
        } else {
            this.cloneDeepData = cloneDeep(this.truckloadForm);
            let postData = this.getRequestDataTruckload();
            // let totalPallet: any = sum(map(postData.manifest_lines, 'manifest_carton'));

            // if (totalPallet > this.max_pallet) {
            //   this.err('Please wait for approval from your sales representative.');
            //   return;
            // }

            if (this.isRequestnewquote) this.$delete(postData, 'input_quote_id');
            if (postData.total_freight_value == null) postData.total_freight_value = 'null';
            this.isCalculating = true;
            this.errorTopBarMessage = '';
            this.shouldShowErrorTopBar = false;
            tmsServiceBackend
                .post('quote/tmsMileService', qs.stringify(postData))
                .then(response => {
                    this.isCalculating = false;
                    if (parseInt(response.data.status) <= 0) {
                        this.err(response.data.message);
                        this.truckloadForm = this.cloneDeepData;
                        this._zipAutoCompletes();
                        return;
                    }
                    const data = response.data.data;
                    if (data && data.quote_id > 0) {
                        this.truckloadForm.quoteNumber = data.quote_id;
                        if (params) {
                          localStorageUtil.setItemToStorage('quoteData_' + data.quote_id, params);
                        }
                        this.routerPush(data.quote_id);
                    }
                })
                .catch(err => {
                    this.isCalculating = false;
                });
        }
    }

    getExpirationDate() {
        let date = this.getDate();
        return moment(moment(date).add(7, 'days')).format('YYYY-MM-DD');
    }

    getDate() {
        let date_now = new Date();
        let date_month = date_now.getMonth() + 1;
        let date_day = date_now.getDate();
        let date_year = date_now.getFullYear();
        let dd: string = '';
        let mm: string = '';

        if (date_day < 10) {
            dd = '0' + date_day;
        } else {
            dd = date_day.toString();
        }
        if (date_month < 10) {
            mm = '0' + date_month;
        } else {
            mm = date_month.toString();
        }
        return date_year + '-' + mm + '-' + dd;
    }

    getRequestDataLastmile() {
        let shipper_zipcode, shipper_state, shipper_city;
        if (this.lm_shipper_isUnisFacility) {
            let facility = this.unisFacilities.find(
                o => o.id == this.lastMileForm.shipper_selectedUnisFacility
            );
            if (facility) {
                shipper_zipcode = facility.zipCode;
                shipper_state = facility.state;
                shipper_city = facility.city;
            } else {
            }
        } else {
            shipper_zipcode = this.lastMileForm.shipper_zipcode;
            shipper_state = this.lastMileForm.shipper_state;
            shipper_city = this.lastMileForm.shipper_city;
        }
        let requestData = {
            UserID: localStorage.getItem('UserID'),
            UserToken: localStorage.getItem('UserToken'),
            input_batch: 0,
            input_billing_party: '1',
            input_billto_id: this.billToId,
            input_consignee_city: this.lastMileForm.consignee_city,
            input_consignee_contact: '',
            input_consignee_id: '',
            input_consignee_name: '',
            input_consignee_phone: '',
            input_consignee_state: this.lastMileForm.consignee_state,
            input_consignee_street: '',
            input_consignee_warehouse: null,
            input_consignee_zip: this.lastMileForm.consignee_zipcode,
            input_debug: 0,
            input_dray_manifest_id: 0,
            input_drayage_port: '0',
            input_equipment_type: '0',
            input_internal_notes: '',
            input_mastertariff_id: '0',
            input_notes: this.lastMileForm.comments,
            input_quote_expiration_date: this.getExpirationDate(),
            input_quote_id: this.lastMileForm.quoteNumber,
            input_savequote: 1,
            input_shipby: 0,
            input_shipment_date: moment(this.lastMileForm.shipper_estimateShippingDate).format(
                'YYYY-MM-DD'
            ),
            input_shipment_id: '0',
            input_shipper_city: shipper_city,
            input_shipper_contact: '',
            input_shipper_id: this.myAccountData.shipping.locationId,
            input_shipper_name: '',
            input_shipper_phone: '',
            input_shipper_state: shipper_state,
            input_shipper_street: '',
            input_shipper_warehouse: null,
            input_shipper_zip: shipper_zipcode,
            input_single: 1,
            input_trip_id: '0',
            input_value: '',
            input_shipper_address_type: this.lastMileForm.shipper_type,
            input_consignee_address_type: '',
            input_shipper_wise_facility_id: this.lastMileForm.shipper_selectedUnisFacility,
            input_consignee_wise_facility_id: '',
            input_pickup_location_type: this.lastMileForm.shipper_selectedBusinessType,
            input_delivery_location_type: '', // this.lm_consignee_selectedBusinessType,
            manifest_lines: this.getManifestLinesLastmile(),
        };
        return requestData;
    }

    getManifestLinesLastmile() {
        let manifestLines: Array<Object> = [];
        this.lastMileForm.selectedAdditionalServices.forEach((item: any) => {
            let line = Object.assign({}, this.manifestLineTemplate);
            line.manifest_code = item.code;
            line.manifest_code_id = 0;
            line.manifest_content = item.name;
            manifestLines.push(line);
        });

        this.lastMileForm.shippingProducts.forEach((item: any) => {
            let volume_detail = {
                palletType: '',
                width: item.width,
                length: item.length,
                height: item.height,
                isStackable: item.isPalletsStackable,
            };

            let line = {
                manifest_product_id: item.selectedProduct,
                manifest_pallet_dimension_id: '',
                manifest_carton: item.quantity,
                manifest_class: '',
                manifest_code: '',
                manifest_code_id: 0,
                manifest_content: item.newProductName,
                manifest_line_id: 2,
                manifest_linear: '',
                manifest_pallet: item.quantity,
                manifest_space: item.palletSpace,
                manifest_value: '',
                manifest_volume: item.width * item.length * item.height,
                volume_details: [volume_detail],
                manifest_weight: item.weight,
                manifest_isROC: item.isRoomOfChoice,
                manifest_isWG: item.isWhiteGlovePackagingRemoval,
                save_product: item.isSaveItemToProducts,
            };
            manifestLines.push(line);
        });

        return manifestLines;
    }

    getRequestDataSharedTruckload() {
        const form = this.sharedTruckloadForm;
        let shipper_zipcode,
            shipper_state,
            shipper_city,
            consignee_zipcode,
            consignee_state,
            consignee_city;
        if (this.stl_shipper_isUnisFacility) {
            let facility = this.unisFacilities.find(o => o.id == form.shipper_selectedUnisFacility);
            if (facility) {
                shipper_zipcode = facility.zipCode;
                shipper_state = facility.state;
                shipper_city = facility.city;
            }
        } else {
            shipper_zipcode = form.shipper_zipcode;
            shipper_state = form.shipper_state;
            shipper_city = form.shipper_city;
        }

        if (this.stl_consignee_isUnisFacility) {
            let facility = this.unisFacilities.find(
                o => o.id == form.consignee_selectedUnisFacility
            );
            if (facility) {
                consignee_zipcode = facility.zipCode;
                consignee_state = facility.state;
                consignee_city = facility.city;
            } else {
            }
        } else {
            consignee_zipcode = form.consignee_zipcode;
            consignee_state = form.consignee_state;
            consignee_city = form.consignee_city;
        }
        let requestData = {
            UserID: localStorage.getItem('UserID'),
            UserToken: localStorage.getItem('UserToken'),
            input_batch: 0,
            input_billing_party: '1',
            total_freight_value: form.total_freight_value,
            input_billto_id: this.billToId,
            input_consignee_city: consignee_city,
            input_consignee_contact: '',
            input_consignee_id: '',
            input_consignee_name: '',
            input_consignee_phone: '',
            input_consignee_state: consignee_state,
            input_consignee_street: '',
            input_consignee_warehouse: null,
            input_consignee_zip: consignee_zipcode,
            input_debug: 0,
            input_dray_manifest_id: 0,
            input_drayage_port: '0',
            input_equipment_type: '0',
            input_internal_notes: '',
            input_mastertariff_id: '0',
            input_notes: form.comments,
            input_quote_expiration_date: this.getExpirationDate(),
            input_quote_id: form.quoteNumber,
            input_savequote: 1,
            input_shipby: 0,
            input_shipment_date: this.getDate(),
            input_shipment_id: '0',
            input_shipper_city: shipper_city,
            input_shipper_contact: '',
            input_shipper_id: this.myAccountData.shipping.locationId,
            input_shipper_name: '',
            input_shipper_phone: '',
            input_shipper_state: shipper_state,
            input_shipper_street: '',
            input_shipper_warehouse: null,
            input_shipper_zip: shipper_zipcode,
            input_single: 1,
            input_trip_id: '0',
            input_value: '',
            input_shipper_address_type: form.shipper_type,
            input_consignee_address_type: form.consignee_type,
            input_shipper_wise_facility_id: form.shipper_selectedUnisFacility,
            input_consignee_wise_facility_id: form.consignee_selectedUnisFacility,
            input_pickup_location_type: form.shipper_selectedBusinessType,
            input_delivery_location_type: form.consignee_selectedBusinessType,
            manifest_lines: this.getManifestLinesSharedTruckload(),
        };
        return requestData;
    }

    getManifestLinesSharedTruckload() {
        let manifestLines: Array<Object> = [];

        if (this.sharedTruckloadForm.shipper_isLiftGateRequired) {
            let line: any = this.getManifestLine('PL');
            if (Object.keys(line).length > 0) {
                manifestLines.push(line);
            }
        }
        if (this.sharedTruckloadForm.consignee_isLiftGateRequired) {
            let line: any = this.getManifestLine('DL');
            if (Object.keys(line).length > 0) {
                manifestLines.push(line);
            }
        }

        this.sharedTruckloadForm.selectedAdditionalServices.forEach((item: any) => {
            let line = Object.assign({}, this.manifestLineTemplate);
            line.manifest_code = item.code;
            line.manifest_code_id = 0;
            line.manifest_content = item.name;
            manifestLines.push(line);
        });

        this.sharedTruckloadForm.shippingProducts.forEach((item: any) => {
            let volume_detail = {
                palletType: '',
                width: item.width,
                length: item.length,
                height: item.height,
                isStackable: item.isPalletsStackable,
            };

            let line = {
                manifest_product_id: item.selectedProduct,
                manifest_pallet_dimension_id: item.selectedPalletDimension,
                manifest_carton: item.quantity,
                manifest_class: item.class,
                manifest_code: '',
                manifest_code_id: 0,
                manifest_content: item.newProductName,
                manifest_line_id: 2,
                manifest_linear: '',
                manifest_pallet: item.quantity,
                manifest_space: item.palletSpace,
                manifest_value: '',
                manifest_volume: item.width * item.length * item.height,
                volume_details: [volume_detail],
                manifest_weight: item.weight,
                save_product: item.isSaveItemToProducts,
            };
            manifestLines.push(line);
        });

        return manifestLines;
    }

    getRequestDataTruckload() {
        let shipper_zipcode,
            shipper_state,
            shipper_city,
            consignee_zipcode,
            consignee_state,
            consignee_city;
        if (this.tl_shipper_isUnisFacility) {
            let facility = this.unisFacilities.find(
                o => o.id == this.truckloadForm.shipper_selectedUnisFacility
            );
            if (facility) {
                shipper_zipcode = facility.zipCode;
                shipper_state = facility.state;
                shipper_city = facility.city;
            } else {
            }
        } else {
            shipper_zipcode = this.truckloadForm.shipper_zipcode;
            shipper_state = this.truckloadForm.shipper_state;
            shipper_city = this.truckloadForm.shipper_city;
        }

        if (this.tl_consignee_isUnisFacility) {
            let facility = this.unisFacilities.find(
                o => o.id == this.truckloadForm.consignee_selectedUnisFacility
            );
            if (facility) {
                consignee_zipcode = facility.zipCode;
                consignee_state = facility.state;
                consignee_city = facility.city;
            } else {
            }
        } else {
            consignee_zipcode = this.truckloadForm.consignee_zipcode;
            consignee_state = this.truckloadForm.consignee_state;
            consignee_city = this.truckloadForm.consignee_city;
        }
        let requestData = {
            UserID: localStorage.getItem('UserID'),
            UserToken: localStorage.getItem('UserToken'),
            input_batch: 0,
            input_billing_party: '1',
            total_freight_value: this.truckloadForm.total_freight_value,
            input_billto_id: this.billToId,
            input_consignee_city: consignee_city,
            input_consignee_contact: '',
            input_consignee_id: '',
            input_consignee_name: '',
            input_consignee_phone: '',
            input_consignee_state: consignee_state,
            input_consignee_street: '',
            input_consignee_warehouse: null,
            input_consignee_zip: consignee_zipcode,
            input_debug: 0,
            input_dray_manifest_id: 0,
            input_drayage_port: '0',
            input_equipment_type: '0',
            input_internal_notes: '',
            input_mastertariff_id: '0',
            input_notes: this.truckloadForm.comments,
            input_quote_expiration_date: this.getExpirationDate(),
            input_quote_id: this.truckloadForm.quoteNumber,
            input_savequote: 1,
            input_shipby: 0,
            input_shipment_date: this.getDate(),
            input_shipment_id: '0',
            input_shipper_city: shipper_city,
            input_shipper_contact: '',
            input_shipper_id: this.myAccountData.shipping.locationId,
            input_shipper_name: '',
            input_shipper_phone: '',
            input_shipper_state: shipper_state,
            input_shipper_street: '',
            input_shipper_warehouse: null,
            input_shipper_zip: shipper_zipcode,
            input_single: 1,
            input_trip_id: '0',
            input_value: '',
            input_shipper_address_type: this.truckloadForm.shipper_type,
            input_consignee_address_type: this.truckloadForm.consignee_type,
            input_shipper_wise_facility_id: this.truckloadForm.shipper_selectedUnisFacility,
            input_consignee_wise_facility_id: this.truckloadForm.consignee_selectedUnisFacility,
            input_pickup_location_type: this.truckloadForm.shipper_selectedBusinessType,
            input_delivery_location_type: this.truckloadForm.consignee_selectedBusinessType,
            manifest_lines: this.getManifestLinesTruckload(),
        };
        return requestData;
    }

    getManifestLinesTruckload() {
        let manifestLines: Array<Object> = [];

        // TODO 复选框选中时，push 到 manifestLines
        if (this.truckloadForm.shipper_isLiftGateRequired) {
            let line: any = this.getManifestLine('PL');
            if (Object.keys(line).length > 0) {
                manifestLines.push(line);
            }
        }
        if (this.truckloadForm.consignee_isLiftGateRequired) {
            let line: any = this.getManifestLine('DL');
            if (Object.keys(line).length > 0) {
                manifestLines.push(line);
            }
        }
        // additional services 选中时，push 到 manifestLines
        this.truckloadForm.selectedAdditionalServices.forEach((item: any) => {
            // if (item.code != 'PL' && item.code != 'DL') {
            let line = Object.assign({}, this.manifestLineTemplate);
            line.manifest_code = item.code;
            line.manifest_code_id = 0;
            line.manifest_content = item.name;
            manifestLines.push(line);
            // }
        });

        // TODO 循环 products， push 到 manifestLines
        this.truckloadForm.shippingProducts.forEach((item: any) => {
            let volume_detail = {
                palletType: '',
                width: item.width,
                length: item.length,
                height: item.height,
                isStackable: item.isPalletsStackable,
            };

            let line = {
                manifest_product_id: item.selectedProduct,
                manifest_pallet_dimension_id: item.selectedPalletDimension,
                manifest_carton: item.quantity,
                manifest_class: item.class,
                manifest_code: '',
                manifest_code_id: 0,
                manifest_content: item.newProductName,
                manifest_line_id: 2,
                manifest_linear: '',
                manifest_pallet: item.quantity,
                manifest_space: item.palletSpace,
                manifest_value: '',
                manifest_volume: item.width * item.length * item.height,
                volume_details: [volume_detail],
                manifest_weight: item.weight,
                save_product: item.isSaveItemToProducts,
            };
            manifestLines.push(line);
        });

        return manifestLines;
    }

    getManifestLine(ac_code: string) {
        let line = Object.assign({}, this.manifestLineTemplate);
        const accItem: any = this.accList.find((o: any) => o.tms_acc_name_code == ac_code);
        if (accItem) {
            line.manifest_code = accItem.tms_acc_name_code;
            line.manifest_code_id = accItem.tms_acc_name_id;
            line.manifest_content = accItem.tms_acc_name_name;
            return line;
        }
        return {};
    }

    //#endregion 请求接口

    //#region  验证

    async validate() {}

    //#endregion 验证

    //#region
    editQuote() {
        this.isEditMode = true;
    }

    //#region 数据回填
    getQuoteAndFillForm(query: any) {
        const supportedQuoteTypes = new Set(['lastmile', 'truckload', 'sharedTruckload']);
        if (!supportedQuoteTypes.has(query.quoteType)) {
            return;
        }

        let url = 'write_new/get_tms_quote_line.php';
        let request = {
            input_search_quote_id: null,
            input_search_date_from: '',
            input_search_date_to: '',
            billto_id: this.billToId,
            quote_id: query.quoteNumber,
            input_search_shipper_state: '',
            input_search_shipper_zip: null,
            input_search_consignee_state: '',
            input_search_consignee_zip: null,
            input_search_status: 0,
            input_search_limit: 1,
            quote: 0,
            pageName: 'dashboardQuote',
        };

        tmsService.post(url, request).then((response: any) => {
            const data = response.data;
            if (query.quoteType == 'lastmile') {
                this.isTruckload = false;
                this.isLastmile = true;
                this.isSharedTruckload = false;
                this.lastMileForm.quoteNumber = query.quoteNumber;
                this.lastMileForm.shipper_type = data.shipper_address_type;
                this.lastMileForm.shipper_selectedUnisFacility = data.shipper_wise_facility_id;
                this.lastMileForm.shipper_selectedBusinessType =
                    data.tms_quote_pickup_location_type;
                this.lastMileForm.shipper_zipcode = data.tms_quote_client_zip;
                this.lastMileForm.shipper_state = data.tms_quote_client_state;
                this.lastMileForm.shipper_city = data.tms_quote_client_city;
                this.lastMileForm.shipper_estimateShippingDate = data.tms_quote_appointment_date;

                this.lastMileForm.consignee_zipcode = data.tms_quote_consignee_zip;
                this.lastMileForm.consignee_state = data.tms_quote_consignee_state;
                this.lastMileForm.consignee_city = data.tms_quote_consignee_city;
                this.lastMileForm.shippingProducts = this.getShippingProductsLastmile(data.m_lines);
            }

            if (query.quoteType == 'sharedTruckload') {
                this.isTruckload = false;
                this.isLastmile = false;
                this.isSharedTruckload = true;
                this.sharedTruckloadForm.quoteNumber = query.quoteNumber;
                this.sharedTruckloadForm.shipper_type = data.shipper_address_type;
                this.sharedTruckloadForm.shipper_selectedUnisFacility =
                    data.shipper_wise_facility_id;
                this.sharedTruckloadForm.shipper_selectedBusinessType =
                    data.tms_quote_pickup_location_type;
                this.sharedTruckloadForm.shipper_zipcode = data.tms_quote_client_zip;
                this.sharedTruckloadForm.shipper_state = data.tms_quote_client_state;
                this.sharedTruckloadForm.shipper_city = data.tms_quote_client_city;

                this.sharedTruckloadForm.consignee_type = data.consignee_address_type;
                this.sharedTruckloadForm.consignee_selectedUnisFacility =
                    data.consignee_wise_facility_id;
                this.sharedTruckloadForm.consignee_selectedBusinessType =
                    data.tms_quote_delivery_location_type;
                this.sharedTruckloadForm.consignee_zipcode = data.tms_quote_consignee_zip;
                this.sharedTruckloadForm.consignee_state = data.tms_quote_consignee_state;
                this.sharedTruckloadForm.consignee_city = data.tms_quote_consignee_city;
                this.sharedTruckloadForm.total_freight_value =
                    data.tms_quote_total_freight_value || '';
                this.sharedTruckloadForm.shippingProducts = this.getShippingProductsTruckload(
                    data.m_lines
                );
                this.checkedManifestLinesTruckload = data.m_lines;
                this.sharedTruckloadForm.comments = data.tms_quote_note || '';
            }

            if (query.quoteType == 'truckload') {
                this.isTruckload = true;
                this.isLastmile = false;
                this.isSharedTruckload = false;
                this.truckloadForm.quoteNumber = query.quoteNumber;
                this.truckloadForm.shipper_type = data.shipper_address_type;
                this.truckloadForm.shipper_selectedUnisFacility = data.shipper_wise_facility_id;
                this.truckloadForm.shipper_selectedBusinessType =
                    data.tms_quote_pickup_location_type;
                this.truckloadForm.shipper_zipcode = data.tms_quote_client_zip;
                this.truckloadForm.shipper_state = data.tms_quote_client_state;
                this.truckloadForm.shipper_city = data.tms_quote_client_city;

                this.truckloadForm.consignee_type = data.consignee_address_type;
                this.truckloadForm.consignee_selectedUnisFacility = data.consignee_wise_facility_id;
                this.truckloadForm.consignee_selectedBusinessType =
                    data.tms_quote_delivery_location_type;
                this.truckloadForm.consignee_zipcode = data.tms_quote_consignee_zip;
                this.truckloadForm.consignee_state = data.tms_quote_consignee_state;
                this.truckloadForm.consignee_city = data.tms_quote_consignee_city;
                this.truckloadForm.total_freight_value = data.tms_quote_total_freight_value || '';
                this.truckloadForm.shippingProducts = this.getShippingProductsTruckload(
                    data.m_lines
                );
                // this.checkAdditionalService(data.m_lines); // watch if additionalAccList is ready
                this.checkedManifestLinesTruckload = data.m_lines;
                // this.getShippingProducts(data.m_lines);
            }
        });
    }

    getShippingProductsTruckload(m_lines: any) {
        let shippingProducts: any = [];
        m_lines.forEach((line: any) => {
            if (!line.shipment_code) {
                let obj: any = {};
                obj.id = line.shipment_line_id;
                obj.selectedProduct = line.shipment_product_id;
                obj.newProductName = line.shipment_content;
                obj.selectedPalletDimension = line.shipment_pallet_dimension_id;
                obj.quantity = line.shipment_carton;
                if (line.volume_details[0].width == '0.00') line.volume_details[0].width = '';
                if (line.volume_details[0].length == '0.00') line.volume_details[0].length = '';
                if (line.volume_details[0].height == '0.00') line.volume_details[0].height = '';
                obj.width = line.volume_details[0].width;
                obj.length = line.volume_details[0].length;
                obj.height = line.volume_details[0].height;
                obj.weight = line.shipment_weight;
                obj.class = line.shipment_class;
                obj.isPalletsStackable = line.volume_details[0].isStackable == '0' ? false : true;
                obj.isSaveItemToProducts = false;
                if (
                    line.shipment_carton > 0 ||
                    line.volume_details[0].width > 0 ||
                    line.volume_details[0].length > 0 ||
                    line.volume_details[0].height > 0 ||
                    line.shipment_product_id > 0 ||
                    line.shipment_pallet_dimension_id > 0
                ) {
                    obj.showDetail = true;
                    this.$forceUpdate();
                }
                shippingProducts.push(Object.assign({}, obj));
            }
        });

        return shippingProducts;
    }

    getShippingProductsLastmile(m_lines: any) {
        let shippingProducts: any = [];
        m_lines.forEach((line: any) => {
            if (!line.shipment_code) {
                let obj: any = {};
                obj.id = line.shipment_line_id;
                obj.selectedProduct = line.shipment_product_id;
                obj.newProductName = line.shipment_content;
                obj.selectedPalletDimension = line.shipment_pallet_dimension_id;
                obj.quantity = line.shipment_carton;
                obj.width = line.volume_details[0].width;
                obj.length = line.volume_details[0].length;
                obj.height = line.volume_details[0].height;
                obj.weight = line.shipment_weight;
                obj.class = line.shipment_class;
                obj.isPalletsStackable = line.volume_details[0].isStackable == '0' ? false : true;
                obj.isSaveItemToProducts = false;
                obj.isRoomOfChoice = line.shipment_is_roc == 'y' ? true : false;
                obj.isWhiteGlovePackagingRemoval = line.shipment_is_wg == 'y' ? true : false;
                shippingProducts.push(Object.assign({}, obj));
            }
        });
        return shippingProducts;
    }

    destroyed() {
        this.popError({
            isRemove: true,
        });
    }

  generateTimeArray() {
    const timeArr = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const formattedHour = hour < 10 ? '0' + hour : '' + hour;
        const formattedMinute = minute < 10 ? '0' + minute : '' + minute;
        timeArr.push(`${formattedHour}:${formattedMinute}`);
      }
    }
    return timeArr;
  }
  getEditData(quoteNumber: string | undefined) {
    let quoteDataKey = 'quoteData_' + quoteNumber;
    this.quoteData = localStorageUtil.getItemFromStorage(quoteDataKey);
    if ( this.quoteData == undefined) {
        return;
      }
    if (this.quoteData.appointment_date == undefined) {
      return;
    }
    let now = new Date();
    let date = new Date(this.quoteData.appointment_date + 'T' + this.quoteData.latest_time + ':00');
    if (now.getTime() > date.getTime()) {
      return;
    }
    this.truckloadForm.appointment_date = Moment(
      this.quoteData.appointment_date
    ).format('MM/DD/yyyy');
    if (!this.truckloadForm.earliest_time) {
      this.truckloadForm.earliest_time = this.quoteData.earliest_time;
    }
    if (!this.truckloadForm.latest_time) {
      this.truckloadForm.latest_time = this.quoteData.latest_time;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/quote/index.ts